import { render, staticRenderFns } from "./job-setup-area-browser.component.vue?vue&type=template&id=4c60611c"
import script from "./job-setup-area-browser.component.ts?vue&type=script&lang=ts&external"
export * from "./job-setup-area-browser.component.ts?vue&type=script&lang=ts&external"
import style0 from "./job-setup-area-browser.component.vue?vue&type=style&index=0&id=4c60611c&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c60611c')) {
      api.createRecord('4c60611c', component.options)
    } else {
      api.reload('4c60611c', component.options)
    }
    module.hot.accept("./job-setup-area-browser.component.vue?vue&type=template&id=4c60611c", function () {
      api.rerender('4c60611c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/job-setup/job-setup-area-browser/job-setup-area-browser.component.vue"
export default component.exports